/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkContactPropertyRequest
 */
export interface LinkContactPropertyRequest {
    /**
     * 
     * @type {number}
     * @memberof LinkContactPropertyRequest
     */
    propertyId: number;
    /**
     * 
     * @type {string}
     * @memberof LinkContactPropertyRequest
     */
    addressType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LinkContactPropertyRequest
     */
    isPrimary?: boolean;
}

/**
 * Check if a given object implements the LinkContactPropertyRequest interface.
 */
export function instanceOfLinkContactPropertyRequest(value: object): value is LinkContactPropertyRequest {
    if (!('propertyId' in value) || value['propertyId'] === undefined) return false;
    return true;
}

export function LinkContactPropertyRequestFromJSON(json: any): LinkContactPropertyRequest {
    return LinkContactPropertyRequestFromJSONTyped(json, false);
}

export function LinkContactPropertyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkContactPropertyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'propertyId': json['propertyId'],
        'addressType': json['addressType'] == null ? undefined : json['addressType'],
        'isPrimary': json['isPrimary'] == null ? undefined : json['isPrimary'],
    };
}

export function LinkContactPropertyRequestToJSON(json: any): LinkContactPropertyRequest {
    return LinkContactPropertyRequestToJSONTyped(json, false);
}

export function LinkContactPropertyRequestToJSONTyped(value?: LinkContactPropertyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'propertyId': value['propertyId'],
        'addressType': value['addressType'],
        'isPrimary': value['isPrimary'],
    };
}

